<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">账户设置</el-breadcrumb-item>
            <el-breadcrumb-item>基本信息</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="detail-box">
            <div class="detail-item">
                <div class="item-title">
                    商户信息
                </div>
                <div class="item-table">
                    <div class="item-table__column">
                        <div class="item">
                            <div class="item__label">
                                商户名称
                            </div>
                            <div class="item__value">
                                {{ info.company }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="item__label">
                                法人代表
                            </div>
                            <div class="item__value">
                                {{ info.corporation }}
                            </div>
                        </div>
                    </div>
                    <div class="item-table__column">
                        <div class="item">
                            <div class="item__label">
                                营业注册号
                            </div>
                            <div class="item__value">
                                {{ info.registration }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="item__label">
                                营业期限
                            </div>
                            <div class="item__value">
                                {{ info.start_time }} 至 {{ info.end_time }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item-table__full__column">
                    <div class="item">
                        <div class="item__label">
                            成员邀请码
                        </div>
                        <div class="item__value">
                            <el-button @click="downloadQR" type="text" style="padding: 0">下载二维码</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail-item">
                <div class="item-title flex-box">
                    <div class="item-title__text">
                        联系人信息
                    </div>
                    <div class="item-title__handler"/>
                </div>
                <div class="item-table">
                    <div class="item-table__column">
                        <div class="item">
                            <div class="item__label">
                                联系人姓名
                            </div>
                            <div class="item__value">
                                {{ info.contact_name }}
                            </div>
                        </div>
                    </div>
                    <div class="item-table__column">
                        <div class="item">
                            <div class="item__label">
                                联系电话
                            </div>
                            <div class="item__value">
                                {{ encrypted }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item-table__full__column">
                    <div class="item">
                        <div class="item__label">
                            联系邮箱
                        </div>
                        <div class="item__value">
                            {{ info.email }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail-item">
                <div class="item-title flex-box">
                    <div class="item-title__text">
                        结算信息
                    </div>
                    <div class="item-title__handler">
                        <el-button
                            v-if="info.bank_card === ''"
                            type="text"
                            size="small"
                            @click="goPage('/index/info/modcard?handler=0')"
                        >
                            设置结算账户
                        </el-button>
                        <el-button
                            v-else
                            type="text"
                            size="small"
                            @click="goPage('/index/info/modcard?handler=1')"
                        >
                            修改结算账户
                        </el-button>
                    </div>
                </div>
                <div class="item-table">
                    <div class="item-table__column">
                        <div class="item">
                            <div class="item__label">
                                开户名称
                            </div>
                            <div class="item__value">
                                {{ info.bank_name }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="item__label">
                                开户支行
                            </div>
                            <div class="item__value">
                                {{ info.bank_addr }}
                            </div>
                        </div>
                    </div>
                    <div class="item-table__column">
                        <div class="item">
                            <div class="item__label">
                                开户银行城市
                            </div>
                            <div class="item__value">
                                {{ info.bank_city }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="item__label">
                                银行帐户
                            </div>
                            <div class="item__value">
                                {{ info.bank_card }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import atob from 'atob'

export default {
    name: 'Main',
    inject: ['goPage'],
    data () {
        return {
            info: {}
        }
    },
    mounted () {
        this.getInfo()
    },
    computed: {
        encrypted () {
            let phone = this.info.phone || ''
            return phone.substring(0, 3) + ' **** ' + phone.substring(phone.length - 4)
        }
    },
    methods: {
        getInfo () {
            this.$http.get('/api/user/userinfo')
                .then(res => {
                    if (res.code === 0) {
                        this.info = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        download (blob) {
            let eleLink = document.createElement('a')
            eleLink.style.display = 'none'
            eleLink.href = URL.createObjectURL(blob)
            eleLink.download = '小程序二维码'
            document.body.appendChild(eleLink)
            eleLink.click()
            URL.revokeObjectURL(eleLink.href)
            document.body.removeChild(eleLink)
        },
        downloadQR () {
            let dataURI = 'data:image/png;base64,' + this.info.qrcode
            let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0] // mime类型
            let byteString = atob(dataURI.split(',')[1]) // base64 解码
            let arrayBuffer = new ArrayBuffer(byteString.length) // 创建缓冲数组
            let intArray = new Uint8Array(arrayBuffer) // 创建视图

            for (var i = 0; i < byteString.length; i++) {
                intArray[i] = byteString.charCodeAt(i)
            }
            this.download(new Blob([intArray], { type: mimeString }))
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/sub.scss";
</style>
